module.exports = __webpack_public_path__ + "static/media/logo.573151f2.svg";